function isIndexedDBSupport() {
    if (typeof window === 'undefined') {
        return false;
    }
    for (const property of [
        'indexedDB',
        'IDBDatabase',
        'IDBObjectStore',
        'IDBTransaction',
        'IDBIndex',
        'IDBCursor',
        'IDBKeyRange',
        'IDBRequest'
    ]) {
        // @ts-ignore
        if (!window.hasOwnProperty(property) || !window[property]) {
            return false;
        }
    }
    return true;
}

export { isIndexedDBSupport };
//# sourceMappingURL=envChecker.js.map
